export const ConferenceProviderParticipantText = (provider) => `This programme takes place on ${provider}, please make sure you have ${provider} downloaded and setup.`;
